module.exports = __webpack_public_path__ + "img/bulk-sender.e1fe1c85.svg";